import {
  Box,
  Flex,
  Text,
  Center,
  Button,
  Image,
  Input,
} from "@chakra-ui/react";
// import { ChevronRightIcon } from "@chakra-ui/icons";
import { useEffect, useMemo, useState } from "react";
import { useAppSelector } from "@/state/hooks";
import Jumio from "@/pages/lagacyUser/jumio/JumioSDK";
import { useI18n } from "@/hooks/useI18n";
import "dayjs/locale/zh-cn";
import { useVerifyIdentity } from "@/pages/newKyc/person/baseInfo/verifyHooks.js";
import { useCommonHooks } from "@/pages/newKyc/person/baseInfo/verifyHooks.js";
import BXNSelect from "@/components/ui/WSelect";
import { toastTip } from "@/components/ui/toast";

const Step = ["info", "jumio"];

const VerifyIdentity = (props) => {
  const { setStep } = props;

  const [verifyIdentityStep, setVerifyIdentityStep] = useState(Step[0]);
  // const [identityData, setIdentityData] = useState({
  //   id_type: "",
  //   first_name: "",
  //   last_name: "",
  //   country: "",
  // });
  const [inputParams, setInputParams] = useState({
    country: "",
    id_type: "",
    first_name: "",
    last_name: "",
  });
  const [areaScanError, setAreaScanError] = useState(false); // 证件发行地 制裁区错误
  const [areaCompliantError, setAreaCompliantError] = useState(false); // 证件发行地非合规错误
  const [otherCountryAreaError, setOtherCountryAreaError] = useState(false); // 其他国家 不为合规区 错误
  const [cardTypeDisabled, setCardTypeDisabled] = useState(false);

  const { t } = useI18n();
  const _lang = useAppSelector((state) => state.user.language);

  const { memoCardList } = useVerifyIdentity();
  const { allCountryList, sanctionsCountryList, noCompliantCountryList } =
    useCommonHooks();

  const inputOnChange = (value, key) => {
    setInputParams((prev) => {
      const SEPECIAL_KEYS = [
        "transaction_purpose",
        "products_services",
        "wealth_source",
        "fund_source",
      ];
      if (SEPECIAL_KEYS.indexOf(key) < 0) {
        const obj = { [key]: value };
        return Object.assign({}, prev, obj);
      } else {
        // 增加description
        const newObj = prev[key];
        newObj.description = value;
        return Object.assign({}, prev, {
          [key]: newObj,
        });
      }
    });
  };

  // 判断能不能去下一步
  const toNextPage = () => {
    const FIRST_PAGE_KEYS = [
      "first_name", // 名
      "last_name", // 姓
      // "gender",
      "id_type",
      // "id_number",
      "country",
      // "nationality",
      // "birth_place",
      // "birth_date",
      // "occupation",
      // "occupation_industry",
      // "employer_name",
    ];

    // // 护照 + 制裁区
    // if (inputParams?.id_type === "PASSPORT" && areaScanError) {
    //   toastTip(t("mzWsFtJNWfexuuUgYctv"), { type: "error" });
    //   return;
    // }

    // // 护照 + 非合规区 + 没有其他其他国家有效身份证
    // if (
    //   inputParams?.id_type === "PASSPORT" &&
    //   areaCompliantError &&
    //   (Number(inputParams?.has_other_country_id_card?.value) === 2 ||
    //     !inputParams?.has_other_country_id_card)
    // ) {
    //   toastTip(t("mzWsFtJNWfexuuUgYctv"), { type: "error" });
    //   return;
    // }

    // // 护照 + 非合规区 + 有其他其他国家有效身份证 + 没有选其他国家
    // if (
    //   inputParams?.id_type === "PASSPORT" &&
    //   areaCompliantError &&
    //   Number(inputParams?.has_other_country_id_card?.value) === 1 &&
    //   !inputParams?.other_country
    // ) {
    //   toastTip(t("QZCxVURndUpletXFScR"), { type: "error" });
    //   return;
    // }

    // // 护照 + 非合规区 + 有其他其他国家有效身份证 + 其他国家地区在制裁区、非合规区
    // if (
    //   inputParams?.id_type === "PASSPORT" &&
    //   areaCompliantError &&
    //   Number(inputParams?.has_other_country_id_card?.value) === 1 &&
    //   inputParams.other_country &&
    //   otherCountryAreaError
    // ) {
    //   toastTip(t("mzWsFtJNWfexuuUgYctv"), { type: "error" });
    //   return;
    // }

    // // 护照 + 非合规区 + 有其他其他国家有效身份证 + 其他国家地区在合规区 + （!没有选证件类型 ｜｜ ！ 没有上传正面文件信息）
    // if (
    //   inputParams?.id_type === "PASSPORT" &&
    //   areaCompliantError &&
    //   Number(inputParams?.has_other_country_id_card?.value) === 1 &&
    //   !otherCountryAreaError &&
    //   (!inputParams?.other_country_card_type ||
    //     !inputParams?.other_country_card_front_file?.[0]?.document_path)
    // ) {
    //   toastTip(t("QZCxVURndUpletXFScR"), { type: "error" });
    //   return;
    // }

    if (FIRST_PAGE_KEYS.some((d) => !inputParams[d])) {
      toastTip(t("QZCxVURndUpletXFScR"), { type: "error" });
      return;
    }

    // const transaction_purpose_options =
    //   inputParams["transaction_purpose"]?.options || [];
    // if (transaction_purpose_options.length === 0) {
    //   toastTip(t("QZCxVURndUpletXFScR"), { type: "error" });
    //   return;
    // }

    // const products_services_options =
    //   inputParams["products_services"]?.options || [];
    // const products_services_desc =
    //   inputParams["products_services"]?.description;

    // if (
    //   products_services_options.length === 0 ||
    //   (products_services_options.findIndex((d) => d.value === 3) > -1 &&
    //     !products_services_desc)
    // ) {
    //   toastTip(t("QZCxVURndUpletXFScR"), { type: "error" });
    //   return;
    // }

    setVerifyIdentityStep(Step[1]);
  };

  // 证件发行地国家
  const selectCountry = (value) => {
    inputOnChange(value.iso_code2, "country");
    setAreaScanError(false);
    setAreaCompliantError(false);
    // 在制裁区 + 美国、美国本土外小岛
    if (
      sanctionsCountryList.indexOf(value.iso_code2) > -1 ||
      value.iso_code2 === "US" ||
      value.iso_code2 === "UM"
    ) {
      setAreaScanError(true);
      return;
    }

    // 非合规区
    if (noCompliantCountryList.indexOf(value.iso_code2) > -1) {
      setAreaCompliantError(true);
      return;
    }
  };

  // const memoCountry = useMemo(() => {
  //   if (identityData?.country && allCountryList) {
  //     const item = allCountryList.filter(
  //       (d) => d.iso_code2 === identityData.country
  //     )[0];
  //     if (_lang === "zh") return item?.zh_name;
  //     return item?.en_name;
  //   }
  // }, [identityData, allCountryList, _lang]);

  const memoCountryList = useMemo(() => {
    if (allCountryList && allCountryList.length > 0) {
      return allCountryList.map((d) => {
        return {
          ...d,
          label: d.zh_name,
          value: d.value,
        };
      });
    }
  }, [allCountryList]);

  // 默认证件发行地国家 未做选择时 默认是香港
  const defaultCountry = useMemo(() => {
    if (memoCountryList?.length > 0) {
      if (inputParams.country) {
        return memoCountryList.filter(
          (d) => d.iso_code2 === inputParams.country
        )[0];
      } else {
        return memoCountryList?.filter((d) => d.iso_code2 === "HK")[0];
      }
    }
  }, [inputParams.country, memoCountryList]);

  // 证件类型
  const memoCardType = useMemo(() => {
    return [
      {
        label: t("MTiCVGmtBjEPWzsw"),
        value: "ID_CARD",
      },
      {
        label: t("bRDTmhggLlBbrbdtfhM"),
        value: "PASSPORT",
      },
    ];
  }, [t]);

  useEffect(() => {
    if (memoCountryList?.length > 0) {
      const defaultItem = memoCountryList?.filter(
        (d) => d.iso_code2 === "HK"
      )[0];
      if (!inputParams.country) {
        inputOnChange(defaultItem.iso_code2, "country");
      }
    }
  }, [memoCountryList]);

  const renderItem = (item) => {
    return (
      <Flex alignItems={"center"}>
        <Text fontSize="12px">
          {`${_lang === "zh" ? item.zh_name : item.en_name}  (+${
            item.dial_code
          })`}
        </Text>
      </Flex>
    );
  };

  return (
    <Box
      style={{ backgroundColor: "#fff" }}
      height={"auto"}
      minHeight={"100vh"}
      overflow={"hidden"}
      pt={"60px"}
    >
      {Step[0] === verifyIdentityStep && (
        <Flex
          width={["95%", "400px"]}
          flexDirection={"column"}
          margin={"0 auto"}
        >
          <Center>
            <Image src="../../wwwsite/images/kyc/user.svg" />
            <Text fontSize={32} fontWeight={700} ml={"10px"}>
              {t("CRMoLKUrfyLkDWFEuSu")}
            </Text>
          </Center>

          {/* 名 姓 */}
          <Flex mt={"40px"} alignItems={"flex-end"}>
            <Flex flexDirection={"column"} flex={"1"}>
              <Text fontSize="14px" fontWeight={400}>
                {t("THMxZAxLcuuIfPErpGb")}
              </Text>
              <Input
                h="44px"
                fontSize="12px"
                color="t.100"
                borderRadius={"12px"}
                placeholder={t("idqLvJqjeiEmQbpa")}
                mt="10px"
                maxLength={100}
                value={inputParams.first_name}
                onChange={(e) => inputOnChange(e.target.value, "first_name")}
              />
            </Flex>
            <Flex flexDirection={"column"} flex={"1"} ml={"20px"}>
              <Text fontSize="14px" fontWeight={400}>
                {t("bTWntlsiiBougPgd")}
              </Text>
              <Input
                h="44px"
                fontSize="12px"
                color="t.100"
                borderRadius={"12px"}
                placeholder={t("idqLvJqjeiEmQbpa")}
                mt="10px"
                maxLength={100}
                onChange={(e) => inputOnChange(e.target.value, "last_name")}
                value={inputParams.last_name}
              />
            </Flex>
          </Flex>

          {/* 证件类型 */}
          <Flex mt={"30px"} flexDirection={"column"}>
            <Text fontSize="14px" fontWeight={600}>
              {t("VALtZMIyzODbkpPUOsxG")}
            </Text>
            <Flex mt={"10px"}>
              {memoCardType.map((d, i) => {
                return (
                  <Flex ml={i === 1 && "40px"} key={i} align={"center"}>
                    <Image
                      w={"18px"}
                      onClick={() => inputOnChange(d.value, "id_type")}
                      cursor={"pointer"}
                      src={`../../wwwsite/images/kyc/radio${
                        inputParams.id_type === d.value ? "_checked" : ""
                      }.svg`}
                    />
                    <Text fontSize={"14px"} color={"t.100"} ml={"4px"}>
                      {d.label}
                    </Text>
                  </Flex>
                );
              })}
            </Flex>
          </Flex>

          {/* 证件发行地 */}
          <Flex mt={"20px"} flexDirection={"column"}>
            <Text fontSize="14px" fontWeight={400}>
              {t("xjuVMsJZTRgjPgAzSV")}
            </Text>
            <Box mt={"15px"}>
              <BXNSelect
                disabled={cardTypeDisabled}
                options={memoCountryList}
                defaultOpt={defaultCountry}
                renderLabel={(item) => renderItem(item)}
                renderItem={(item) => renderItem(item)}
                handleSelect={(item) => {
                  selectCountry(item);
                }}
              ></BXNSelect>
              {areaScanError && (
                <Text color={"#D04457"} fontSize={"14px"} mt={"5px"}>
                  {t("mzWsFtJNWfexuuUgYctv")}
                </Text>
              )}
            </Box>
          </Flex>

          <Flex justifyContent={"center"} mt="30px" mb={"50px"}>
            <Button
              fontSize="14px"
              padding="0 30px"
              w={["100%", "200px"]}
              bg="blue.100"
              color="#fff"
              fontWeight={"400"}
              borderRadius={"30px"}
              _hover={{ bg: "blue.80" }}
              h="44px"
              cursor={"pointer"}
              onClick={() => toNextPage()}
            >
              {t("tOaRBVUJHpnSgDBrGON")}
            </Button>
          </Flex>
        </Flex>
      )}
      {Step[1] === verifyIdentityStep && (
        <Flex justifyContent={"center"}>
          <Box flexDirection={"column"} justifyContent={"center"}>
            <Jumio
              setVerifyIdentityStep={setVerifyIdentityStep}
              identityData={inputParams}
              setStep={setStep}
            />
          </Box>
        </Flex>
      )}
    </Box>
  );
};

export default VerifyIdentity;
